import Menu from '../../../lib/menu';
export default Menu;
